var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C14.4183 8 18 6.65685 18 5C18 3.34315 14.4183 2 10 2C5.58172 2 2 3.34315 2 5C2 6.65685 5.58172 8 10 8ZM16.9297 8.5C15.5465 9.3967 12.9611 10 10 10C7.03887 10 4.4535 9.3967 3.07026 8.5C2.38958 8.94126 2 9.45357 2 10C2 11.6569 5.58172 13 10 13C14.4183 13 18 11.6569 18 10C18 9.45357 17.6104 8.94126 16.9297 8.5ZM16.9297 13.5C15.5465 14.3967 12.9611 15 10 15C7.03887 15 4.4535 14.3967 3.07026 13.5C2.38958 13.9413 2 14.4536 2 15C2 16.6569 5.58172 18 10 18C14.4183 18 18 16.6569 18 15C18 14.4536 17.6104 13.9413 16.9297 13.5Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicText);
export default __webpack_public_path__ + "static/media/dynamic-text.2435cdcdbd4de5253db13c7d5a709e5d.svg";
export { ForwardRef as ReactComponent };